import parse, { HTMLReactParserOptions } from 'html-react-parser';

import { FAQIds } from '@util/constants';

const hideFAQOptions: HTMLReactParserOptions = {
  replace({ attribs }: any) {
    if (!attribs) {
      return;
    }

    if (attribs.id === FAQIds.QUESTION || attribs.id === FAQIds.ANSWER) {
      return <></>;
    }
  },
};

export const hideFAQParser = (html: string) => parse(html, hideFAQOptions);
